import { CONTACT_FIELD_CODES } from "src/core/constants/contact";
import { FolderFileQuery, InputValue } from "src/core/gql/graphql";
import { Contact, Owner } from "src/core/types/contact";

/**
 * Mapping de l'owner (expert comptable) du dossier.
 * @TODO: il faudrait p-e le déplacer dans la brand/expert-comptable.
 */
export const mapOwner = (folderFile: FolderFileQuery): Owner | null => {
  const ownerNode = folderFile.folderFile?.currentCustomerFolder?.owner;

  const owner: Owner | null = ownerNode
    ? {
        id: ownerNode.id,
        firstName: ownerNode.firstName ?? undefined,
        lastName: ownerNode.lastName ?? undefined,
      }
    : null;

  return owner;
};

/**
 * Mapping du contact du dossier.
 * @TODO: il faudrait p-e le déplacer dans la brand/expert-comptable.
 */
export const mapContact = (folderFile: FolderFileQuery): Contact | null => {
  // Il faut utiliser currentCustomerFolder car fileCustomerFolder peut contenir
  // l'id du snapshot qui lui n'est pas éditable.
  const contactNode = folderFile.folderFile?.currentCustomerFolder?.contactPerson;
  const contactInputs = contactNode?.inputValues as InputValue[] | undefined;

  const contactPerson: Contact | null = contactNode
    ? {
        id: contactNode.id,
        firstName: findInputValue(contactInputs ?? [], CONTACT_FIELD_CODES.firstName) ?? null,
        lastName: findInputValue(contactInputs ?? [], CONTACT_FIELD_CODES.lastName) ?? null,
        email: findInputValue(contactInputs ?? [], CONTACT_FIELD_CODES.email) ?? null,
        phone: findInputValue(contactInputs ?? [], CONTACT_FIELD_CODES.phone) ?? null,
      }
    : null;

  return contactPerson;
};

/** @TODO: le laisser dans core, mais plutôt le mettre dans utils.
 * @TODO Mais le réutiliser
 */
export const findInputValue = (inputValues: InputValue[], fieldCode: string): string | null => {
  return inputValues.find((iv) => iv.inputField.fieldCode === fieldCode)?.stringValue ?? null;
};
